<template>
  <v-layout
    ma-0
    pa-0
    py-1
    row
    wrap
  >
    <v-flex
      xs12
      sm10
      :class="['align-start', 'mt-1', {'mx-1 mt-4': $vuetify.breakpoint.xsOnly && !forSummary, 'elevation-2 lg6 md6': !forSummary, 'lg5 md5': forSummary}]"
    >
      <v-layout
        row
        wrap
        class="px-4"
        :class="{'pt-3': !forSummary}"
      >
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <span class="label">{{
            $t('message.bizgainOnboarding.postText')
          }}</span>
        </v-flex>
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <custom-text-area
            :name="'postText'"
            :validation="'required'"
            :error-messages="$t('message.bizgainOnboarding.postTextValidationMessage')"
            :classes="'ma-0 pa-0 body-1'"
            :auto-grow="true"
            :rows="'1'"
            v-model="postText"
            :icon="isShortenFlow ? 'mdi-check' : ''"
          />
        </v-flex>
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <span
            class="label"
          >{{ $t('message.bizgainOnboarding.headline')
          }}<sub
            class="ml-1 font-weight-light caption align-self-end"
          >{{ $t('message.bizgainOnboarding.optional') }}</sub></span>
        </v-flex>
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <custom-text-field
            :classes="'ma-0 pa-0 body-1'"
            v-model="headline"
            :icon="isShortenFlow ? 'mdi-check' : ''"
          />
        </v-flex>
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <span
            class="label"
          >{{ $t('message.bizgainOnboarding.description')
          }}<sub
            class="ml-1 font-weight-light caption align-self-end"
          >{{ $t('message.bizgainOnboarding.optional') }}</sub></span>
        </v-flex>
        <v-flex
          xs12
          md12
          sm12
          lg12
        >
          <custom-text-field
            :classes="'ma-0 pa-0 body-1'"
            v-model="description"
            :icon="isShortenFlow ? 'mdi-check' : ''"
          />
        </v-flex>
        <v-layout
          row
          wrap
          v-if="showCallToAction"
        >
          <v-flex
            xs12
            md12
            sm12
            lg12
          >
            <span class="label">{{
              $t('message.bizgainOnboarding.callToAction')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            md12
            sm12
            lg12
          >
            <v-select
              append-icon="keyboard_arrow_down"
              :items="callToActions"
              item-text="label"
              item-value="value"
              v-model="callToAction"
              class="ma-0 pa-0"
            />
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
    <v-flex
      :class="{ 'd-none': $vuetify.breakpoint.xsOnly, 'elevation-2 lg6': !forSummary, 'lg7': forSummary, 'separator': forSummary && $vuetify.breakpoint.mdAndUp}"
      xs12
      md6
      sm10
      class="align-center mt-1 pl-1"
    >
      <facebook-instagram-ad-preview
        :facebook-ad-details="facebookAdDetails"
        :extracted-creative-details="extractedCreativeDetails"
        :template="template"
        :show-facebook-preview="true"
        :show-instagram-preview="true"
        :align-start="true"
        :enable-shimmer-loader="false"
        :custom-scroll-id="forSummary ? 'summaryPageDialog' : 'id'"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import {
  VLayout,
  VFlex,
  VSelect
} from 'vuetify/lib';
import FacebookInstagramAdPreview from '../../imageCreativesAdPreview/components/FacebookInstagramAdPreview';
import { mapGetters, mapActions } from 'vuex';
import CustomTextField from '../../../../../components/Input/CustomTextField.vue';
import CustomTextArea from '../../../../../components/Input/CustomTextArea.vue';
import { bizgainOnboardingRoutes, objectiveType, callToActions, onboardingSections, supportedCtaForObjectives, signupFlowSteps, subsequentFlowSteps } from 'Features/bizgainOnboarding/constants';
import { generateFacebookAdDetails, extractCreativeDetails } from '../../../helpers/templateHelper';
export default {
  async created() {
    if(this.isShortenFlow){
      this.setCurrentSection(onboardingSections.signup);
      if(this.isInAppCampaign){
        this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name);
        this.setSubsequentSteps(subsequentFlowSteps);
      }
      else{
        this.setCurrentRoute(bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name);
        this.setSignUpSteps(signupFlowSteps);
      }
    }
    else{
      this.setCurrentSection(onboardingSections.CREATIVE);
      if(this.isInAppCampaign){
        this.setCurrentRoute(bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name);
      }
      else{
        if(!this.forSummary){
          this.setCurrentRoute(bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name);
        }
      }
    }

    this.template = this.editedBusinessDetails.creativeDetail.templates.find((x) => x.id == this.id);
    this.updateFacebookAdDetails();
    this.extractedCreativeDetails = extractCreativeDetails(this.editedBusinessDetails);
    if(this.showCallToAction){
      this.callToActions = Object.values(callToActions).filter(callToAction=> supportedCtaForObjectives[this.objective].includes(callToAction));
    }
  },
  props: {
    editedBusinessDetails: {
      default: null,
      type: Object
    },
    forSummary: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      settingsY: {
        suppressScrollX: true
      },
      isUpdated: false,
      extractedCreativeDetails: null,
      facebookAdDetails: null,
      template: null,
      bizgainOnboardingRoutes,
      callToActions: []
    };
  },
  methods: {
    ...mapActions([
      'setCurrentRoute',
      'setCurrentSection',
      'patchBusinessDetails',
      'updateBusinessDetails',
      'updateMessage',
      'setSignUpSteps',
      'setSubsequentSteps'
    ]),
    updateFacebookAdDetails(){
      this.facebookAdDetails = generateFacebookAdDetails(this.editedBusinessDetails);
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'objective', 'isInAppCampaign', 'roimaticConfiguration']),
    isShortenFlow(){
      if(this.businessDetails && this.businessDetails.shortenFlow){
        return true;
      }
      else if(this.roimaticConfiguration && this.roimaticConfiguration.shortenFlow){
        return true;
      }
      return false;
    },
    showCallToAction(){
      return this.objective != objectiveType.calls.id;
    },
    id() {
      return this.$route.params.id ? this.$route.params.id : this.businessDetails.creativeDetail.selectedTemplateId;
    },
    selectedTemplate() {
      return this.businessDetails.creativeDetail.templates.find(x => x.id == this.id);
    },
    headline: {
      get() {
        return this.editedBusinessDetails.creativeDetail.adDetail.displayAd.headline;
      },
      set(value) {
        this.editedBusinessDetails.creativeDetail.adDetail.displayAd.headline = value;
        this.updateFacebookAdDetails();
      }
    },
    description: {
      get() {
        return this.editedBusinessDetails.creativeDetail.adDetail.displayAd
          .description;
      },
      set(value) {
        this.editedBusinessDetails.creativeDetail.adDetail.displayAd.description = value;
        this.updateFacebookAdDetails();
      }
    },
    postText: {
      get() {
        return this.editedBusinessDetails.creativeDetail.adDetail.displayAd.postText;
      },
      set(value) {
        this.editedBusinessDetails.creativeDetail.adDetail.displayAd.postText = value;
        this.updateFacebookAdDetails();
      }
    },
    callToAction: {
      get() {
        return this.editedBusinessDetails.creativeDetail.adDetail.displayAd.callToAction;
      },
      set(value) {
        this.editedBusinessDetails.creativeDetail.adDetail.displayAd.callToAction = value;
        this.updateFacebookAdDetails();
      }
    }
  },
  components: {
    VLayout,
    VFlex,
    FacebookInstagramAdPreview,
    VSelect,
    CustomTextField,
    CustomTextArea
  }
};
</script>
<style lang="scss" scoped>
.label{
     padding-top: 2px !important;
     padding-bottom: 2px !important;
     padding-left: 0px !important;
}
.separator{
  border-left: 1px solid #aaaaaa;
}
</style>
